// Figma star (29.29 x 28.05 viewBox); inline so it can take currentColor.
export const STAR_VIEW_BOX = '0 0 29.29 28.05';
export const STAR_PATH = [
  'M12.7977 1.23194C13.4809 -0.410644 15.8078 -0.410648 16.491 1.23194L19.0685 7.42909',
  'C19.3565 8.12156 20.0078 8.5947 20.7553 8.65463L27.4457 9.191C29.219 9.33316 29.9381 11.5462 28.587 12.7035',
  'L23.4896 17.0699C22.9201 17.5578 22.6713 18.3234 22.8453 19.0529L24.4027 25.5815',
  'C24.8154 27.312 22.9329 28.6797 21.4147 27.7524L15.6869 24.2538C15.0468 23.8629 14.2419 23.8629 13.6018 24.2538',
  'L7.87397 27.7524C6.35577 28.6797 4.47327 27.312 4.88604 25.5815L6.44336 19.0529',
  'C6.61738 18.3234 6.36863 17.5578 5.79906 17.0699L0.701719 12.7035C-0.649355 11.5462 0.0696938 9.33316 1.843 9.191',
  'L8.53335 8.65463C9.28093 8.5947 9.93215 8.12156 10.2202 7.42909L12.7977 1.23194Z',
].join('');
